/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the OtpRequest interface.
 */
export function instanceOfOtpRequest(value) {
    if (!('email' in value) || value['email'] === undefined)
        return false;
    return true;
}
export function OtpRequestFromJSON(json) {
    return OtpRequestFromJSONTyped(json, false);
}
export function OtpRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'email': json['email'],
    };
}
export function OtpRequestToJSON(json) {
    return OtpRequestToJSONTyped(json, false);
}
export function OtpRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'email': value['email'],
    };
}
